/**
 * Le registre des routes poussées de l'espace élève : la fusion des `routes.ts` de chaque lot.
 *
 * C'est la seule table que `studentSpaceBridge` lit. Un lot n'écrit que dans son propre
 * `routes.ts`, qui ne peut inscrire que ses routes (`StudentSpaceRouteTable<lot>`) : les lots
 * travaillent en parallèle sans se marcher dessus, et ce fichier ne bouge plus après le socle.
 *
 * Une entrée est l'écran seul (rendu hors live seulement) ou `livesInLive(écran)` (rendu aussi en
 * live) : `studentSpaceRouteTypes.ts`.
 */
import { accountRoutes } from "./Account/routes"
import { activitiesRoutes } from "./Activities/routes"
import { activityRoutes } from "./Activity/routes"
import { assessmentsRoutes } from "./Assessments/routes"
import { gameRoutes } from "./Game/routes"
import { homeRoutes } from "./Home/routes"
import { liveRoutes } from "./Live/routes"
import { liveEntryRoutes } from "./LiveEntry/routes"
import { messagingRoutes } from "./Messaging/routes"
import { tutoringRoutes } from "./Tutoring/routes"
import { type StudentSpaceRouteEntry, type StudentSpaceRouteName } from "./studentSpaceRouteTypes"

export const studentSpaceRoutes: Partial<Record<StudentSpaceRouteName, StudentSpaceRouteEntry>> = {
    ...homeRoutes,
    ...activitiesRoutes,
    ...tutoringRoutes,
    ...messagingRoutes,
    ...accountRoutes,
    ...gameRoutes,
    ...assessmentsRoutes,
    ...activityRoutes,
    ...liveEntryRoutes,
    ...liveRoutes,
}
